module.exports = __webpack_public_path__ + "static/media/menu-datasets-icon.a07c82a0.svg";